import { useSelector, useDispatch } from "react-redux";
import { Container, Stack, Typography, TextField } from "@mui/material";
import BullseyeIcon from "assets/images/icons/bullseye.svg";

import { setMissionStatement, selectMissionStatement } from "../slice";

const MissionStatementStep = () => {
    const dispatch = useDispatch();
    const missionStatement = useSelector(selectMissionStatement);

    return (
        <Container maxWidth="sm" sx={{ my: 3 }}>
            <Stack alignItems="center" gap={1.5}>
                <img src={BullseyeIcon} alt="Bullseye" width={35} height={35} />
                <Typography fontWeight="500" color="text.mediumDark">
                    Tell us your mission
                </Typography>
                <TextField
                    color="secondary"
                    value={missionStatement}
                    onChange={(e) =>
                        dispatch(setMissionStatement(e.target.value))
                    }
                    placeholder="Our mission is to..."
                    multiline
                    minRows={5}
                    fullWidth
                />
            </Stack>
        </Container>
    );
};

export default MissionStatementStep;
